import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { map } from 'ramda';
import Button from '../button/Button.jsx';
import Spacer from '../spacer/Spacer.jsx';
import Tooltip, { RIGHT, INFO } from '../tooltip/Tooltip';

import s from './AlertModal.module.scss';

const iconColor = color => {
    return {
        [s.green]: color === 'green',
        [s.gray]: color === 'gray',
        [s.red]: color === 'red',
    };
};

const AlertMessages = ({ options }) => {
    const createTextField = textFieldOptions => {
        return (
            <React.Fragment key={textFieldOptions.text}>
                <div className={classNames(s.alertText, textFieldOptions.className)}>
                    {textFieldOptions.text}
                    {textFieldOptions.link ? <a href={textFieldOptions.link} target="_blank" rel="noopener noreferrer">{`${textFieldOptions.link}.`}</a> : null}
                </div>
                <Spacer height={24} />
            </React.Fragment>
        );
    };

    return options ? map(createTextField, options) : <Spacer height={24} />;
};

const AlertModal = ({ options }) => (
    <div className={s.alert} data-cy='AlertModal'>
        <div className={classNames(options.icon, s.alertIcon, iconColor(options.iconColor))} />
        <div className={s.title}>{options.title}</div>
        <button type="button" onClick={options.handleClose} className={classNames('icon-close', s.closeIcon)}>
            <Tooltip arrowPosition={RIGHT} type={INFO} text="Close" form />
        </button>
        <AlertMessages options={options.textOptions} />
        <Button label={options.buttonText} onClick={options.handleSubmit} color="blue" className={s.alertButton} />
    </div>
);

AlertModal.propTypes = { options: PropTypes.object.isRequired };

export default AlertModal;
